import React from 'react';
import PositionCard from '../components/PositionCard';
import { positions } from '../utils/mockData';
const PositionMapping = () => {
  return <div data-id="element-229">
      <div className="mb-6" data-id="element-230">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-231">Position Mapping</h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-232">
          Stakeholder positions and compromise opportunities
        </p>
      </div>
      <div className="bg-white rounded-lg shadow p-5 mb-8" data-id="element-233">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-234">
          Compromise Opportunities
        </h2>
        <div className="space-y-4" data-id="element-235">
          <div className="p-3 bg-blue-50 rounded-lg" data-id="element-236">
            <p className="text-sm text-gray-800 font-medium" data-id="element-237">
              Implementation Timeline Extension
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-238">
              Could satisfy 48% of stakeholders with minor policy adjustments
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg" data-id="element-239">
            <p className="text-sm text-gray-800 font-medium" data-id="element-240">
              Targeted Financial Support
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-241">
              Could address 37% of economic concerns while maintaining standards
            </p>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg" data-id="element-242">
            <p className="text-sm text-gray-800 font-medium" data-id="element-243">
              Co-Governance Framework
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-244">
              Could satisfy Treaty concerns while maintaining policy objectives
            </p>
          </div>
        </div>
      </div>
      <div className="mb-8" data-id="element-245">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-246">
          Position Analysis
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-247">
          {positions.map((position, index) => <PositionCard key={index} position={position.position} count={position.count} percentage={position.percentage} stakeholders={position.stakeholders} compromiseOpportunity={position.compromiseOpportunity} confidence={position.confidence} data-id="element-248" />)}
        </div>
      </div>
    </div>;
};
export default PositionMapping;